define([
	"dojo/_base/declare",
	"./_RevisedGapMixin",
	"./RevisedPatternWithShrinkage"
], function(declare,_RevisedGapMixin,RevisedPatternWithShrinkage) {

	return declare([RevisedPatternWithShrinkage,_RevisedGapMixin]);
});